import moment from 'moment-timezone'

export default {
  //available by time
  available(item, timezone) {
    if (!item) {
      return false
    }
    const msNow = moment().utc().valueOf()

    //we are getting store time, convert it to utc according to store timezone
    const itemStartDateTime = moment
      .tz(item.from_date + ' ' + item.from, 'YYYY-MM-DD HH:mm', timezone)
      .utc()
      .valueOf()

    let itemEndtDateTime = moment
      .tz(item.until_date + ' ' + item.until, 'YYYY-MM-DD HH:mm', timezone)
      .utc()
      .valueOf()

    if (item.until === '00:00') {
      //that means next date
      itemEndtDateTime = moment
        .tz(item.until_date + ' ' + item.until, 'YYYY-MM-DD HH:mm', timezone)
        .add(1, 'days')
        .utc()
        .valueOf()
    }

    if (msNow < itemStartDateTime || msNow > itemEndtDateTime) {
      return false
    }

    const todayStoreDate = moment().tz(timezone).format('YYYY-MM-DD')

    const itemStartTime = moment
      .tz(todayStoreDate + ' ' + item.from, 'YYYY-MM-DD HH:mm', timezone)
      .utc()
      .valueOf()
    let incrementDay = 0
    if (item.from) {
      const itemStartHour = parseInt(item.from.split(':')[0])
      const itemStartMin = parseInt(item.from.split(':')[1])
      const itemEndHour = parseInt(item.until.split(':')[0])
      const itemEndMin = parseInt(item.until.split(':')[1])

      if (itemStartHour == itemEndHour) {
        //check minutes, time may be like 00:35 => 00:10
        if (itemStartMin > itemEndMin) {
          incrementDay = 1
        }
      } else if (itemStartHour > itemEndHour) {
        //time may be 09:00 => 01:34
        incrementDay = 1
      }
    }

    let itemEndTime = moment
      .tz(todayStoreDate + ' ' + item.until, 'YYYY-MM-DD HH:mm', timezone)
      .add(incrementDay, 'days')
      .utc()
      .valueOf()

    if (item.until === '00:00') {
      itemEndTime = moment
        .tz(todayStoreDate + ' ' + item.until, 'YYYY-MM-DD HH:mm', timezone)
        .add(1, 'days')
        .utc()
        .valueOf()
    }

    if (item.from === '00:00' && item.until === '00:00') {
      //console.log('24 hours open discount')
    } else if (msNow < itemStartTime || msNow > itemEndTime) {
      return false
    }

    let dayToday = moment().utc().tz(timezone).day()

    dayToday -= 1
    if (dayToday < 0) {
      dayToday = 6
    }

    /*
    mon tue wed thu fri sat sun
    0   1   2   3   4   5   6
    
    sun mon tue we thu fri sat
    0    1   2  3   4   5   6
    -1   0   1  2   3   4   5 
    6
    */

    return item.available_days.includes(dayToday)
  },
  availableInLocation(item, country, city, store) {
    if (!item) {
      return false
    }
    if (item.store_disable_status && item.store_disable_status.length) {
      if (item.store_disable_status.includes(store)) {
        return false
      }
    }
    if (!item.availability) {
      return true
    }

    const inc = item.availability.incl
    const exc = item.availability.excl
    let available = false

    if (
      inc.all &&
      !exc.all &&
      !exc.countries.includes(country) &&
      !exc.cities.includes(city) &&
      !exc.stores.includes(store)
    ) {
      available = true
    } else if (
      inc.countries.includes(country) &&
      !exc.countries.includes(country) &&
      !exc.cities.includes(city) &&
      !exc.stores.includes(store)
    ) {
      available = true
    } else if (
      inc.cities.includes(city) &&
      !exc.cities.includes(city) &&
      !exc.stores.includes(store)
    ) {
      available = true
    } else if (!store) {
      return true
    } else if (inc.stores.includes(store) && !exc.stores.includes(store)) {
      available = true
    }
    return available
  },
  availableInStore(item, store) {
    if (!item) {
      return false
    }
    if (item.store_disable_status && item.store_disable_status.length) {
      if (item.store_disable_status.includes(store)) {
        return false
      }
    }
    const inc = item.availability.incl
    const exc = item.availability.excl
    let available = false
    if (inc.all && !exc.all && !exc.stores.includes(store)) {
      available = true
    } else if (inc.stores.includes(store) && !exc.stores.includes(store)) {
      available = true
    }
    return available
  },
  availableValue(availability, country = '', city = '', store = '') {
    if (!availability) {
      return false
    }
    let value = availability.all
    if (availability.countries.length && country) {
      const countryEntry = availability.countries.find(
        (entry) => entry.param.toLowerCase() == country.toLowerCase()
      )
      if (countryEntry) {
        value = countryEntry.value
      }
    }

    if (availability.cities.length) {
      const cityEntry = availability.cities.find(
        (entry) => entry.param.toLowerCase() == city.toLowerCase()
      )
      if (cityEntry) {
        value = cityEntry.value
      }
    }

    if (availability.stores.length && store) {
      const storeEntry = availability.stores.find(
        (entry) => entry.param == store
      )
      if (storeEntry) {
        value = storeEntry.value
      }
    }
    // //check if any thing has a value
    // if (!value && value !== 0) {
    //   if (availability.stores.length) {
    //     const storeEntry = availability.stores.find(entry => parseFloat(entry.value) >= 0)
    //     if (storeEntry) {
    //       value = storeEntry.value
    //     }
    //   }
    //   if (availability.cities.length) {
    //     const cityEntry = availability.cities.find(
    //       entry => parseFloat(entry.value) >= 0
    //     )
    //     if (cityEntry) {
    //       value = cityEntry.value
    //     }
    //   }
    //   if (availability.countries.length) {
    //     const countryEntry = availability.countries.find(
    //       entry => parseFloat(entry.value) >= 0
    //     )
    //     if (countryEntry) {
    //       value = countryEntry.value
    //     }
    //   }
    // }

    return value
  },
}
